import { render, staticRenderFns } from "./BaseNavigation.vue?vue&type=template&id=3e82b2c4&scoped=true&"
import script from "./BaseNavigation.vue?vue&type=script&lang=js&"
export * from "./BaseNavigation.vue?vue&type=script&lang=js&"
import style0 from "./BaseNavigation.vue?vue&type=style&index=0&id=3e82b2c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e82b2c4",
  null
  
)

export default component.exports